import React from 'react';
import classNames from 'classnames';
import MenuItem from './MenuItem';

/**
 * @ignore
 */
export default function MenuTitle({
  className,
  prefixCls,
  trigger,
  selected,
  silent,
  disabled,
  ...other
}) {
  const classes = classNames(prefixCls, className, {
    [`${prefixCls}-selected`]: !silent && selected,
    [`${prefixCls}-disabled`]: disabled,
    [`${prefixCls}-trigger`]: trigger,
    [`${prefixCls}-silent`]: silent,
  });
  return (
    <MenuItem className={classes} {...other} disabled={disabled} tag="div" selectable={false} />
  );
}

MenuTitle.defaultProps = {
  prefixCls: 'ne-menu-title',
};



// WEBPACK FOOTER //
// ./src/menu/MenuTitle.jsx